import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useUsersStore } from "@/stores/v2/users";

export const requireAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const userStore = useUsersStore();
  if (!userStore.isLoggedIn) {
    next("/");
  } else {
    next();
  }
};
